<template>
  <div class="text-sm">
    <div class="info-container mb-8 form-container mx-auto">
      <p class="text-lg font-bold">{{ $trans.get("registration.academic-title-btn") }}</p>
    </div>
    <div class="form-container mx-auto">
      <div class="form-container__inputs">
        <!-- ACADEMIC DATA -->
        <!-- OBTAINED DEGREE -->
        <p class="font-semibold mb-5">{{ $trans.get("registration.degree-title") }}</p>
        <p class="mb-3">{{ $trans.get("registration.degree-title-last") }}</p>
        <floating-select-input
            name="obtainedDegreeType"
            class="w-full"
            :initialValue="form.academic.obtainedDegreeType.value"
            :options="[
              { label: $trans.get('registration.cfgm'), value: 'Cfgm o Equivalent' },
              { label: $trans.get('registration.cfgs'), value: 'Cfgs o Equivalent' },
              { label: $trans.get('registration.bat'), value: 'Batxillerat o Equivalent' },
              { label: $trans.get('registration.college'), value: 'Universitat o Equivalentersitat' },
              { label: $trans.get('registration.eso'), value: 'Eso o Equivalent' },
              { label: $trans.get('registration.pqpi'), value: 'Pqpi o Equivalent' },
              { label: $trans.get('registration.unknown'), value: 'desconegut' }
            ]"
            @handle-change="handleDegree"
            :required="true"
          />
        <div class="grid md:grid-cols-2 gap-4 mt-5">
          <div v-for="(item, index) in form.academic.obtainedDegree" :key="index">
            <floating-input
              :name="item.name"
              :placeholder="$trans.get('registration.' + item.name)"
              :initialValue="item.value"
              @handle-change="handleDegreeObtained"
              type="text"
              @blur="validateOdAccessGrade(item)"
              required
              @input.native="removeError($event)"
            />
          </div>
        </div>
        <!-- Pregunta si ya tienen nota media -->
        <p class="mt-6">{{ $trans.get('registration.hasAverageGrade') }}</p>
        <floating-radio-button
          name="hasAverageGrade"
          :initialValue="form.academic.hasAverageGrade.value"
          :options="[
            { label: 'Sí', value: 'si' },
            { label: 'No', value: 'no' }
          ]"
          @handle-change="handleHasAverageGrade"
        />
        <p v-if="form.academic.hasAverageGrade.value === 'no'" class="text-sm text-black my-4" v-html="$trans.get('registration.provisionalRegistrationMessage')"></p>
        <!-- Mostrar input de nota media solo si la respuesta es 'Sí' -->
        <div v-if="form.academic.hasAverageGrade.value === 'si'" class="mt-4 md:w-1/3">
          <floating-input
            name="odAccessGrade"
            :placeholder="$trans.get('registration.odAccessGrade')"
            @handle-change="handleAverageGrade"
            :initialValue="form.academic.odAccessGrade.value"
            type="text"
          />
          <p v-if="form.academic.odAccessGrade.errors.length" class="text-red-500 text-sm">
            {{ form.academic.odAccessGrade.errors[0] }}
          </p>
        </div>

        <!-- Pregunta si ya tienen certificado académico -->
         <div v-if="form.academic.hasAverageGrade.value === 'si'">
           <p class="mt-6">{{ $trans.get('registration.hasAcademicCertificate') }}</p>
           <floating-radio-button
             name="hasAcademicCertificate"
             :initialValue="form.academic.hasAcademicCertificate.value"
             :options="[
               { label: 'Sí', value: 'si' },
               { label: 'No', value: 'no' }
             ]"
             @handle-change="handleAcademicCertificate"
           />
           <!-- STUDY CERTIFICATE OPTIONAL FILES -->
           <div v-show="form.academic.hasAcademicCertificate.value === 'si'" class="mt-4">
             <p class="mt-6 mb-3">{{ $trans.get('registration.studyCertificateOptionalFile') }}</p>
             <label class="addFile addFileAcademic" for="studyCertificateOptionalFile"
               v-if="form.academic.studyCertificateOptionalFile.display ||form.academic.studyCertificateOptionalFile.value.lenght > 0"
             v-html="placeholderFileText"></label>
             <input
             name="studyCertificateOptionalFile"
             @change="addFiles"
             :initialValue="form.academic.studyCertificateOptionalFile.value"
             class="hidden"
             type="file"
             id="studyCertificateOptionalFile"
             />
             <!-- STUDY CERTIFICATE OPTIONAL FILES PROGRESS -->
             <div v-for="(val, index) in form.academic.studyCertificateOptionalFile.value" :key="val.id">
               <progress-file-upload
                 name="studyCertificateOptionalFile"
                 :index=index
                 v-on:click="delFiles"
                 :initialValue="form.academic.studyCertificateOptionalFile"
                 v-if="!form.academic.studyCertificateOptionalFile.display"
               ></progress-file-upload>
             </div>
           </div>
           <p v-if="form.academic.hasAcademicCertificate.value === 'no'" class="text-sm mt-4" v-html="$trans.get('registration.provisionalRegistrationMessage')"></p>
           <!-- Already loaded files -->
           <ul class="list-disc list-inside mt-4">
               <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center" v-if="form.academic.studyCertificateOptionalFile.value != '' && form.academic.studyCertificateOptionalFile.display">{{ form.academic.studyCertificateOptionalFile.value }}
                 <button @click="deleteFile('studyCertificateOptionalFile')" class="ml-2">
                   <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                       <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                           <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                           <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                       </g>
                   </svg>
                 </button>
               </li>
           </ul>
         </div>

         <!-- FOREIGN STUDIES -->
         <p>{{ $trans.get("registration.foreign-studies-title") }}</p>
         <floating-radio-button
           name="foreignStudies"
           title=""
           :initialValue="form.academic.foreignStudies.value"
           :options="[
             { label: 'Sí', value: 'si' },
             { label: 'No', value: 'no' },
           ]"
           @handle-change="handleForeignStudies"
         />

         <div v-show="form.academic.foreignStudies.value === 'si'" class="mt-4">
             <p class="mb-3">{{ $trans.get('registration.hasHomologation') }}</p>
             <floating-radio-button
               name="hasHomologation"
               :initialValue="form.academic.hasHomologation.value"
               :options="[
                 { label: 'Sí', value: 'si' },
                 { label: 'No', value: 'no' }
               ]"
               @handle-change="handleHasHomologation"
             />
           <div v-show="form.academic.hasHomologation.value === 'si'" class="mt-4">
            <p>{{ $trans.get('registration.certificate-of-foreign-grades') }}</p>
             <label class="addFile addFileAcademic" for="foreignStudiesFile"
               v-show="form.academic.foreignStudiesFile.display || form.academic.foreignStudiesFile.value.length > 0"
             v-html="placeholderFileText"></label>
             <input
               name="foreignStudiesFile"
               @change="addForeignStudiesFile"
               :initialValue="form.academic.foreignStudiesFile.value"
               class="hidden"
               type="file"
               id="foreignStudiesFile"
             />

             <div v-for="(val, index) in form.academic.foreignStudiesFile.value" :key="index">
               <progress-file-upload
                 name="foreignStudiesFile"
                 :index="index"
                 v-on:click="delForeignStudiesFile(index)"
                 :initialValue="form.academic.foreignStudiesFile"
                 v-if="!form.academic.foreignStudiesFile.display"
               ></progress-file-upload>
             </div>
               <!-- Already loaded files -->
             <ul class="list-disc list-inside mt-4">
                 <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center" v-if="form.academic.foreignStudiesFile.value != '' && form.academic.foreignStudiesFile.display">{{ form.academic.foreignStudiesFile.value }}
                   <button @click="deleteFile('foreignStudiesFile')" class="ml-2">
                     <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                         <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                             <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                             <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                         </g>
                     </svg>
                   </button>
                 </li>
             </ul>
           </div>
           <div v-if="form.academic.hasHomologation.value === 'no'" class="mt-4">
             <p class="mt-4 text-black" v-html="$trans.get('registration.provisionalRegistrationMessage')"></p>
           </div>
         </div>
         <p class="mb-3 mt-8 font-bold text-lg">{{ $trans.get("registration.latestStudiesCompleted") }}</p>
         <p class="mb-5">{{ $trans.get("registration.latestStudiesCompletedSubtitle") }}</p>

        <p>{{ $trans.get("registration.last-degree-question") }}</p>
        <floating-radio-button
          name="lastStudiesSameAsPrevious"
          title=""
          :initialValue="form.academic.lastStudiesSameAsPrevious.value"
          :options="[
            { label: 'Sí', value: 'si' },
            { label: 'No', value: 'no' },
          ]"
          @handle-change="handleLastStudiesChange"
        />
         <div class="mt-5" v-if="form.academic.lastStudiesSameAsPrevious.value === 'no'">
          <p class="mb-3">{{ $trans.get('registration.level-degree') }}</p>
           <floating-select-input
             name="lastDegreeType"
             class="w-full"
             :initialValue="form.academic.lastDegreeType.value"
             :options="[
             { label: $trans.get('registration.cfgm'), value: 'Cfgm' },
             { label: $trans.get('registration.cfgs'), value: 'Cfgs' },
             { label: $trans.get('registration.bat'), value: 'Batxillerat' },
             { label: $trans.get('registration.college'), value: 'Universitat' },
             { label: $trans.get('registration.eso'), value: 'ESO' },
             { label: $trans.get('registration.pqpi'), value: 'PQPI' },
             { label: $trans.get('registration.other'), value: 'Other' },
             ]"
             @handle-change="handleDegree"
             :disabled="form.academic.lastStudiesSameAsPrevious.value === 'si'"
             :required="true"
           />

         <floating-input
           name="lastDegreeName"
           :placeholder="$trans.get('registration.lastDegreeName')"
           @handle-change="handleDegree"
           :initialValue="form.academic.lastDegreeName.value"
           type="text"
           class="mt-6"
         >
         </floating-input>
         </div>

        <!-- REGISTRATIONS -->
        <p class="font-bold mt-8 mb-5 text-lg">
          {{ $trans.get("registration.registrationDegree") }}
        </p>
        <floating-select-input
          name="registrationDegree"
          class="w-full"
          :initialValue="form.academic.registrationDegree.value"
          :options="courseOptions"
          @handle-change="handleDegree"
          :required="true"
           @input.native="removeError($event)"
        />

        <floating-radio-button
          v-if="
            form.academic.registrationDegree.value == 5
          "
          class="mt-6"
          name="shift"
          :title="$trans.get('registration.shift')"
          :initialValue="form.academic.shift.value"
          :options="[
            {
              label: $trans.get('registration.morning'),
              value: 'M',
            },
            {
              label: $trans.get('registration.afternoon'),
              value: 'T',
            },
          ]"
          @handle-change="handleDegree"
        ></floating-radio-button>
        <floating-radio-button
          name="hasPreviouslyStudied"
          class="my-6"
          :title="$trans.get('registration.has-previously-studied')"
          :initialValue="form.academic.hasPreviouslyStudied.value"
          :options="[
            { label: 'Sí', value: 'si' },
            { label: 'No', value: 'no' },
          ]"
          @handle-change="handlePreviouslyStudied"
        />

        <div v-show="form.academic.hasPreviouslyStudied.value === 'si'" class="mt-4">
          <p class="mt-6 mb-3">{{ $trans.get('registration.certificate-of-grades') }}</p>
          <label class="addFile addFileAcademic" for="previousStudyCertificateFile"
            v-if="form.academic.previousStudyCertificateFile.display || form.academic.previousStudyCertificateFile.value.length > 0"
          v-html="placeholderFileText"></label>
          <input
            name="previousStudyCertificateFile"
            @change="addPreviousStudyCertificateFile"
            :initialValue="form.academic.previousStudyCertificateFile.value"
            class="hidden"
            type="file"
            id="previousStudyCertificateFile"
          />


          <div v-for="(val, index) in form.academic.previousStudyCertificateFile.value" :key="index">
            <progress-file-upload
              name="previousStudyCertificateFile"
              :index="index"
              v-on:click="delPreviousStudyCertificateFile(index)"
              :initialValue="form.academic.previousStudyCertificateFile"
              v-if="!form.academic.previousStudyCertificateFile.display"
            ></progress-file-upload>
          </div>
                <!-- Already loaded files -->
                <ul class="list-disc list-inside mt-4">
                <li class="text-sm overflow-ellipsis overflow-hidden flex justify-between items-center" v-if="form.academic.previousStudyCertificateFile.value != '' && form.academic.previousStudyCertificateFile.display">{{ form.academic.previousStudyCertificateFile.value }}
                  <button @click="deleteFile('previousStudyCertificateFile')" class="ml-2">
                    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <g fill="#000" fill-rule="nonzero" stroke="#F8F8F8">
                            <path d="M12 1C5.92 1 1 5.92 1 12s4.92 11 11 11 11-4.92 11-11S18.08 1 12 1zm0 20.281A9.276 9.276 0 0 1 2.719 12 9.276 9.276 0 0 1 12 2.719 9.276 9.276 0 0 1 21.281 12 9.276 9.276 0 0 1 12 21.281z"/>
                            <path d="M15.866 14.618 13.25 12l2.617-2.618a.883.883 0 0 0-1.248-1.248L12 10.75 9.382 8.134a.883.883 0 1 0-1.248 1.248L10.75 12l-2.617 2.618a.883.883 0 1 0 1.248 1.248L12 13.25l2.618 2.617a.883.883 0 1 0 1.248-1.248z"/>
                        </g>
                    </svg>
                  </button>
                </li>
            </ul>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    academic: {
      type: Object,
      required: false,
    },
    courses: {
      type: Array,
      required: true,
    },
    courseRegistrationId: {
      type: Number,
      required: true,
    }
  },
  data: () => {
    return {
      form: {
        academic: {
          lastStudiesSameAsPrevious:{
              name: "lastStudiesSameAsPrevious",
              value: "si",
              errors: [],
          },
          obtainedDegreeType: {
            name: "obtainedDegreeType",
            value: "",
            errors: [],
          },
          lastDegreeType: {
            name: "lastDegreeType",
            value: "Cfgm",
            errors: [],
          },
          lastDegreeName: {
            name: "lastDegreeName",
            value: "",
            errors: [],
          },
          obtainedDegree: {
            odName: {
              name: "odName",
              value: "",
              errors: [],
            },
            odCentreName: {
              name: "odCentreName",
              value: "",
              errors: [],
            },
            odCityCentre: {
              name: "odCityCentre",
              value: "",
              errors: [],
            },
            odCountryCentre: {
              name: "odCountryCentre",
              value: "",
              errors: [],
            },
          },
            hasAverageGrade: {
            name: "hasAverageGrade",
            value: "si",
            errors: [],
          },
          odAccessGrade: {
            name: "odAccessGrade",
            value: "",
            errors: [],
          },
          hasAcademicCertificate: {
            name: "hasAcademicCertificate",
            value: "si",
            errors: [],
          },
          studyCertificateOptionalFile: {
              name: "studyCertificateOptionalFile",
              value: [],
              display: true,
              maxSize: 1,
              errors: [],
          },
          foreignStudies: {
            name: "foreignStudies",
            value: "",
            errors: [],
          },
          foreignStudiesFile: {
            name: "foreignStudiesFile",
            value: [],
            display: true,
            maxSize: 1,
            errors: [],
          },
          hasHomologation: {
            name: "hasHomologation",
            value: "si",
            errors: [],
          },
          registrationDegree: {
            name: "registrationDegree",
            value: "",
            errors: [],
          },
          shift: {
            name: "shift",
            value: "",
            errors: [],
          },
          hasPreviouslyStudied: {
            name: "hasPreviouslyStudied",
            value: "",
            errors: [],
          },
          previousStudyCertificateFile: {
            name: "previousStudyCertificateFile",
            value: [],
            display: true,
            maxSize: 1,
            errors: [],
          },
        },
      },
      showAccessGradeMessage: true,
      showStudyCertificateMessage: true,
    };
  },
  methods: {
    removeError(event) {
      event.target.classList.remove("border-red-500");
    },
    handleHasHomologation({ value }) {
      this.form.academic.hasHomologation.value = value;
      if (value === "si") {
        this.form.academic.foreignStudiesFile.value = [];
        this.form.academic.foreignStudiesFile.display = true;

        // this.$nextTick(() => {
        //     this.createDropZoneAcademic();
        // })
      }
    },

    handleHasAverageGrade({ value }) {
      this.form.academic.hasAverageGrade.value = value;
      if (value === "no") {
        this.form.academic.odAccessGrade.value = "";
      }
    },

    handleAcademicCertificate({ value }) {
    this.form.academic.hasAcademicCertificate.value = value;
      if (value === "no") {
        this.form.academic.studyCertificateOptionalFile.value = [];
        this.form.academic.studyCertificateOptionalFile.display = true;
      }
    },


    handleAverageGrade({ value }) {
      this.form.academic.odAccessGrade.value = value;
      if (value && !/^\d+(\.\d{1,2})?$/.test(value)) {
        this.form.academic.odAccessGrade.errors = ["Formato inválido (máx. 2 decimales)"];
      } else {
        this.form.academic.odAccessGrade.errors = [];
      }
    },

    deleteFile(fileType) {
    this.form.academic[fileType].value = [];
    this.form.academic[fileType].display = true;
    if (fileType === "studyCertificateOptionalFile") {
      this.showStudyCertificateMessage = true;
    } else if (fileType === "foreignStudiesFile") {
      this.showForeignStudiesMessage = this.form.academic.foreignStudies.value === "si";
    }
  },
    handleDegreeObtained({ value, name }) {
      this.form.academic.obtainedDegree[name].value = value;
      if (name === "odAccessGrade") {
      this.validateOdAccessGrade(this.form.academic.obtainedDegree[name]);
      }
    },
    handleForeignStudies({ value }) {
      this.form.academic.foreignStudies.value = value;
      this.showForeignStudiesMessage = value === "si" && this.form.academic.foreignStudiesFile.value.length === 0;

    //   this.$nextTick(() => {
    //     this.createDropZoneAcademic();
    //   })
    },
    handleLastStudiesChange({ value }) {
      this.form.academic.lastStudiesSameAsPrevious.value = value;

      if (value === "si") {
        // Se autoselecciona el título con el que accedió
        this.form.academic.lastDegreeType.value = this.form.academic.obtainedDegreeType.value;
        this.form.academic.lastDegreeName.value = this.form.academic.obtainedDegree.odName.value;
      } else {
        this.form.academic.lastDegreeType.value = "";
        this.form.academic.lastDegreeName.value = "";
      }
    },
    validateOdAccessGrade(item) {
    if (item.name === "odAccessGrade") {
      const grade = item.value;
      if (grade && !/^\d+(\.\d{1,2})?$/.test(grade)) {
        item.errors = ["Formato inválido (máx. 2 decimales)"];
      } else {
        item.errors = [];
      }
      this.showAccessGradeMessage = !grade;
    }
   },
    handleDegree({ value, name }) {
      this.form.academic[name].value = value;
    },
    addForeignStudiesFile(value) {
      let name = "foreignStudiesFile";
      let arr = [];
      if (this.form.academic[name].value !== undefined && typeof this.form.academic[name].value === 'object') {
        arr = this.form.academic[name].value;
      }
      const time = new Date().getTime();
      const originalFile = value.target.files[0];
      let modifiedFile = new File([originalFile], `${time}_${originalFile.name}`, { type: originalFile.type });
      arr.push(modifiedFile);

      this.form.academic[name].display = false;
      this.form.academic[name].value = arr;

      this.showForeignStudiesMessage = false;
    },
    delForeignStudiesFile(index) {
      let name = "foreignStudiesFile";
      this.form.academic[name].value.splice(index, 1);
      this.showForeignStudiesMessage = this.form.academic.foreignStudies.value === "si" && this.form.academic[name].value.length === 0;
    },
    addPreviousStudyCertificateFile(event) {
      let name = "previousStudyCertificateFile";
      let arr = [];
      if (this.form.academic[name].value !== undefined && typeof this.form.academic[name].value === 'object') {
        arr = this.form.academic[name].value;
      }
      const time = new Date().getTime();
      const originalFile = event.target.files[0];
      let modifiedFile = new File([originalFile], `${time}_${originalFile.name}`, { type: originalFile.type });
      arr.push(modifiedFile);

      this.form.academic[name].display = false;
      this.form.academic[name].value = arr;
    },

    delPreviousStudyCertificateFile(index) {
      let name = "previousStudyCertificateFile";
      this.form.academic[name].value.splice(index, 1);
    },
    addFiles(value){
      let name = value.target.id;
      let arr = [];
      if(this.form.academic[name].value !== undefined && typeof this.form.academic[name].value === 'object'){
        arr = this.form.academic[name].value;
      }

      arr.push(value.target.files[0]);

      this.form.academic[name].display = false;
      this.form.academic[name].value = arr;

      if (name === "studyCertificateOptionalFile") {
        this.showStudyCertificateMessage = false;
      }
    },
    delFiles(name){
      // Eliminamos el elemento utilizando su posicion en el array
      this.form.academic[name].value.splice(index, 1);
      // En caso de que el array contenga datos los guardamos y mostramos el div, en caso de que no contenga datos se setea a null y se oculta
      if(this.form.academic[name].value.length > 0){
        var input = {
          name: name,
          value: this.form.academic[name].value,
          display: false,
          maxSize: this.form.academic[name].maxSize,
          errors: [],
        }
      }else{
        var input = {
          name: name,
          value: null,
          display: true,
          maxSize: this.form.academic[name].maxSize,
          errors: [],
        }
      }

      this.form.academic[name] = input;
      if (name === "studyCertificateOptionalFile") {
        this.showStudyCertificateMessage = true;
      }
    },
    createDropZoneAcademic(){
      window.addEventListener("dragover", (e) => {
        e.preventDefault();
      }, false);
      window.addEventListener("drop", (e) => {
        e.preventDefault();
      }, false);

      let addFiles = document.getElementsByClassName('addFileAcademic');
      for (let n=0; n < addFiles.length; n++) {
        let tmp = addFiles[n];
        tmp.addEventListener('drop', (e) => {
          e.preventDefault();
          // Cogemos el fichero y lo colocamos como valor del input:file
          let tmpFile = e.dataTransfer.files[0];
          let tmpId = e.target.control.id;

          this.addDropFileAcademic(tmpId, tmpFile);
        });
      }
    },
    addDropFileAcademic(name, value){
      // Funcion replica del addFile pero en caso de recibir el documento mediante Drop
      let arr = [];
      if(this.form.academic[name].value !== undefined && typeof this.form.academic[name].value === 'object'){
        arr = this.form.academic[name].value;
      }
      arr.push(value);
      this.form.academic[name].display = false;
      this.form.academic[name].value = arr;
    },
    handlePreviouslyStudied({ value }) {
      this.form.academic.hasPreviouslyStudied.value = value;
    //   this.$nextTick(() => {
    //         this.createDropZoneAcademic();
    //     })
    },
  },
  computed: {
    placeholderFileText(){
        if(window.innerWidth < 768){
            return this.$trans.get("registration.addFilePlaceholderMobile");
        }else{
            return this.$trans.get("registration.addFilePlaceholder");
        }
    },
   currentLanguage() {
      return window.appLocale;
    },
    courseOptions() {
      return this.courses.map(course => {
        return {
          label: course.name[this.currentLanguage] || course.name.es,
          value: course.id,
        };
      });
    },
  },

  created() {
    //Registration Degree
    this.form.academic.registrationDegree.value = this.courseRegistrationId;
    this.form.academic.obtainedDegreeType.value = this.academic?.obtainedDegreeType || 'Cfgm o Equivalent';
    this.form.academic.foreignStudies.value = this.academic.foreignStudies || 'no';
    this.form.academic.hasPreviouslyStudied.value = this.academic.hasPreviouslyStudied || 'no';

    if (!this.academic) return;
    const array = this.form.academic;

    // Obtained degree type
    this.form.academic.lastStudiesSameAsPrevious.value = this.academic.lastDegreeSameAsPrevious;
    this.form.academic.lastDegreeType.value = this.academic?.lastDegreeType || 'Cfgm'
    this.form.academic.lastDegreeName.value = this.academic.lastDegreeName;

    //Obatined Degree
    for (const item in array.obtainedDegree) {
      if (array.obtainedDegree.hasOwnProperty(item)) {
        this.form.academic.obtainedDegree[item].value = this.academic[item];
      }
    }

    this.form.academic.hasAcademicCertificate.value = this.academic.has_academic_certificate ? 'si' : 'si';
    this.form.academic.hasAverageGrade.value = this.academic.has_average_grade ? 'si' : 'si';

    const odAccessGrade = this.form.academic.odAccessGrade;

    this.form.academic.studyCertificateOptionalFile.value = this.academic.studyCertificateOptionalFile;

    //studyCertificateOptionalFile
    this.form.academic.studyCertificateOptionalFile.value = this.academic.studyCertificateOptionalFile;

    //shift
    this.form.academic.shift.value = this.academic.shift;

    //Foreign studies
    this.form.academic.foreignStudiesFile.value = this.academic.foreignStudiesFile;
    this.showForeignStudiesMessage = this.form.academic.foreignStudies.value === "si" && this.form.academic.foreignStudiesFile.value.length === 0;

    this.form.academic.previousStudyCertificateFile.value = this.academic.previousStudyCertificateFile;

  },
  mounted(){
    this.createDropZoneAcademic();
  }
};
</script>

